var _path, _path2, _path3, _path4, _path5, _g, _path6, _path7, _path8, _path9, _path0, _path1, _g2, _path10, _path11, _path12, _path13, _path14, _ellipse, _path15, _path16, _path17, _path18, _g3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEasterChick(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 79 102",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M61.6898 44.0161L70.0898 43.0161L69.0398 53.0161L51.1898 76.0161L7.08984 63.5161V42.5161L9.18984 40.0161L14.9648 41.5161L21.7898 38.5161L30.7148 41.5161L39.6398 37.0161L47.5148 42.5161L56.4398 41.5161L61.6898 44.0161Z",
    fill: "#D8B67C",
    stroke: "#C8A76F",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M48.5991 61.1849L45.0882 61.5349C45.0882 61.5349 44.7141 70.1474 45.7379 72.0036C46.755 73.8536 49.9444 74.3036 52.6679 74.0286C55.2535 73.7661 55.4372 72.1786 55.0697 71.0349C54.7022 69.8911 53.0354 68.8349 51.6507 68.0411C50.5285 67.4036 50.266 65.3161 50.0822 62.3224C49.9838 60.7474 48.5991 61.1849 48.5991 61.1849Z",
    fill: "#FE8F01"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M34.0037 61.3911L28.675 61.7161C28.675 61.7161 28.8259 65.8536 28.5503 67.4349C28.2156 69.3411 24.5603 69.4349 23.4709 70.8974C22.6375 72.0099 23.6744 73.9724 25.9975 74.2411C27.5397 74.4161 31.6019 74.6536 32.9865 72.2786C34.194 70.1974 34.0037 61.3911 34.0037 61.3911Z",
    fill: "#FE8F01"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.7576 30.3036C16.7576 30.3036 14.1719 20.0974 22.9198 10.4786C31.6676 0.859885 47.5554 2.37863 55.5616 10.7099C63.5679 19.0411 61.9666 30.8911 61.9666 30.8911C61.9666 30.8911 65.1691 36.6411 70.0976 40.5099C73.4576 43.1536 79.4623 47.4286 78.1038 50.1286C76.7519 52.8286 75.3935 52.2411 73.0507 52.1224C70.7079 52.0036 63.686 48.7224 63.686 48.7224C63.686 48.7224 62.0848 65.3786 40.0348 65.8536C17.9848 66.3286 14.5394 48.8349 14.5394 48.8349C14.5394 48.8349 5.42413 51.5349 3.94757 51.5349C2.471 51.5349 -0.108059 50.9161 0.00350388 48.1349C0.128191 45.2036 6.041 42.3849 8.50194 40.1599C10.9694 37.9286 15.0316 34.4099 16.7576 30.3036Z",
    fill: "#FFB903"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_217_4461",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 3,
    width: 79,
    height: 63
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M16.7576 30.3036C16.7576 30.3036 14.1719 20.0974 22.9198 10.4786C31.6676 0.859885 47.5554 2.37863 55.5616 10.7099C63.5679 19.0411 61.9666 30.8911 61.9666 30.8911C61.9666 30.8911 65.1691 36.6411 70.0976 40.5099C73.4576 43.1536 79.4623 47.4286 78.1038 50.1286C76.7519 52.8286 75.3935 52.2411 73.0507 52.1224C70.7079 52.0036 63.686 48.7224 63.686 48.7224C63.686 48.7224 62.0848 65.3786 40.0348 65.8536C17.9848 66.3286 14.5394 48.8349 14.5394 48.8349C14.5394 48.8349 5.42413 51.5349 3.94757 51.5349C2.471 51.5349 -0.108059 50.9161 0.00350388 48.1349C0.128191 45.2036 6.041 42.3849 8.50194 40.1599C10.9694 37.9286 15.0316 34.4099 16.7576 30.3036Z",
    fill: "#FFB903"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_217_4461)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M54.0898 65.5161C38.8898 65.9161 23.5903 49.6828 17.5903 42.0161C15.257 46.5161 10.4898 57.1161 12.0898 59.5161C13.6898 61.9161 28.0898 71.5161 35.0898 76.0161C47.7565 72.3495 69.2898 65.1161 54.0898 65.5161Z",
    fill: "#F8A211"
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M53.8917 22.2885C54.0222 20.4736 52.7825 18.9146 51.1227 18.8064C49.4629 18.6982 48.0117 20.0817 47.8812 21.8966C47.7508 23.7115 48.9905 25.2705 50.6503 25.3787C52.31 25.4869 53.7613 24.1034 53.8917 22.2885Z",
    fill: "#2E302D"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M27.9699 25.4425C29.6189 25.2331 30.7509 23.6016 30.4984 21.7985C30.2459 19.9954 28.7044 18.7035 27.0555 18.913C25.4066 19.1224 24.2745 20.7539 24.527 22.557C24.7795 24.3601 26.321 25.652 27.9699 25.4425Z",
    fill: "#2E302D"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M52.1752 21.1465C52.2247 20.4579 51.8181 19.8706 51.267 19.8347C50.7158 19.7987 50.229 20.3278 50.1795 21.0164C50.13 21.705 50.5366 22.2923 51.0877 22.3282C51.6388 22.3642 52.1257 21.8351 52.1752 21.1465Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M27.4286 22.6608C27.9765 22.5912 28.343 21.9806 28.2473 21.2969C28.1515 20.6132 27.6298 20.1154 27.0819 20.185C26.534 20.2546 26.1675 20.8652 26.2632 21.5489C26.3589 22.2326 26.8807 22.7304 27.4286 22.6608Z",
    fill: "white"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M39.0833 27.0185C34.4633 27.1185 33.0786 29.2935 33.0786 30.7122C33.0786 32.381 37.5149 36.081 38.9914 36.081C40.468 36.081 44.9961 32.2122 45.0421 30.7122C45.088 29.306 43.2439 26.931 39.0833 27.0185Z",
    fill: "#FE8F01"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_217_4461",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 33,
    y: 27,
    width: 13,
    height: 10
  }, _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M39.0833 27.0185C34.4633 27.1185 33.0786 29.2935 33.0786 30.7122C33.0786 32.381 37.5149 36.081 38.9914 36.081C40.468 36.081 44.9961 32.2122 45.0421 30.7122C45.088 29.306 43.2439 26.931 39.0833 27.0185Z",
    fill: "#FE8F01"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_217_4461)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M39.6152 26.5161C32.2651 29.0161 36.6402 33.3495 39.6152 36.0161C39.6152 36.3495 39.4052 37.0161 38.565 37.0161C37.7248 37.0161 34.015 35.3495 32.2651 34.5161C31.5651 33.0161 30.4801 29.5161 31.7401 27.5161C33.3151 25.0161 48.5402 25.0161 39.6152 26.5161Z",
    fill: "#F97211"
  }))), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M77.2248 51.4599C77.2248 51.4599 75.6695 53.3536 73.2676 53.5286C70.6754 53.7161 66.4295 53.0911 63.8438 50.8911C61.2582 48.6911 60.6151 43.9411 61.5338 42.9724C62.4591 42.0036 63.8438 46.0724 67.5385 48.2536C71.5416 50.6099 77.2248 51.4599 77.2248 51.4599Z",
    fill: "#F8A211"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M9.24346 48.9537C12.7478 47.4474 17.8141 41.5787 18.3916 42.1787C19.4088 43.2349 18.3719 48.1787 15.2481 50.7162C12.1047 53.2662 7.36658 53.6474 3.38971 52.0662C1.21096 51.1974 0.495642 50.2474 0.187205 49.6599C-0.554358 48.2412 4.53158 50.9787 9.24346 48.9537Z",
    fill: "#F8A310"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M21.7646 19.0162C21.8531 18.8917 21.9439 18.7702 22.0366 18.6521C22.8734 17.5904 23.8578 16.7842 24.9589 16.2567C26.0597 15.7272 27.3028 15.4887 28.6589 15.5033C28.8117 15.5052 28.9589 15.5084 29.1146 15.5162C28.9764 15.444 28.8424 15.3788 28.6984 15.3175C27.4366 14.7606 25.8551 14.7073 24.5275 15.3545C23.1957 15.9838 22.2276 17.2289 21.8667 18.567C21.8257 18.7157 21.7916 18.8659 21.7646 19.0162Z",
    fill: "#FE8E01"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M48.5396 16.677C48.6921 16.6501 48.8441 16.6266 48.9951 16.6065C50.3547 16.4277 51.6454 16.5032 52.821 16.8608C53.9967 17.2155 55.0663 17.8846 56.0208 18.8289C56.1283 18.9355 56.2305 19.0389 56.3355 19.1518C56.2901 19.0073 56.2428 18.8707 56.185 18.7294C55.6963 17.4791 54.5707 16.3559 53.1334 15.932C51.7047 15.491 50.1311 15.7397 48.9299 16.4319C48.7956 16.5084 48.6652 16.5903 48.5396 16.677Z",
    fill: "#FE8E01"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M45.09 3.51616C43.09 3.11616 40.2565 3.68281 39.0898 4.51614C37.2565 5.01615 36.065 5.75371 34.5898 5.01614C32.5898 4.01614 30.5898 3.51616 29.5898 1.01614C32.0898 2.51616 33.8898 3.51615 35.0898 1.51615C36.2898 -0.483854 39.4231 -0.150512 40.5898 0.516155C37.0898 1.01614 35.2004 2.87738 38.09 2.51616C42.0898 2.01614 47.59 4.01616 45.09 3.51616Z",
    fill: "#FFB803"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 46.7348,
    cy: 9.41531,
    rx: 3.5,
    ry: 1.5,
    transform: "rotate(40.0115 46.7348 9.41531)",
    fill: "#FFC738"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_217_4461",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 41,
    width: 72,
    height: 53
  }, _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M7.58965 41.5161L0.764648 47.5161L5.48965 89.0161L42.7646 93.5L71.6396 80.0161V41.5161L56.4146 51.5161L50.6396 45.5161L42.7646 51.5161L36.9896 41.5161L20.7146 55.5161L14.4146 45.5161L9.68965 50.0161L7.58965 41.5161Z",
    fill: "#D9D9D9"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_217_4461)"
  }, _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M7.58984 41.5161L9.68984 50.0161L14.4148 45.5161L20.7148 55.5161L36.9898 41.5161L42.7648 51.5161L50.6398 45.5161L56.4148 51.5161L70.5898 42.5161",
    stroke: "#FFFFFC"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M71.6397 52.0374C71.6397 69.5167 65.9694 90.0161 38.5649 90.0161C11.1605 90.0161 5.48975 69.5167 5.48975 52.0374C5.48975 34.5582 20.2982 5.01614 38.5649 5.01614C56.8317 5.01614 71.6397 34.5582 71.6397 52.0374Z",
    fill: "#FFFEEF"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask3_217_4461",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 5,
    y: 5,
    width: 67,
    height: 85
  }, _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M71.6395 52.0161C71.6395 69.4129 65.9692 89.8157 38.5648 89.8157C11.1605 89.8157 5.48975 69.4129 5.48975 52.0161C5.48975 34.6193 20.2982 5.21655 38.5648 5.21655C56.8315 5.21655 71.6395 34.6193 71.6395 52.0161Z",
    fill: "#D9D9D9"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_217_4461)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.2807 20.5164C36.8646 5.39654 51.4804 5.81653 57.4654 7.91651C57.4654 6.71651 56.8983 3.41653 54.6302 -0.183439C51.7949 -4.6834 26.2807 -1.08343 14.9401 7.91651C3.59954 16.9165 -2.06932 34.0162 -5.84929 68.2159C-8.87326 95.5757 21.2405 97.6156 36.6753 95.2157C51.7952 92.8157 76.606 86.2158 54.6302 86.2158C36.6753 86.2158 26.2807 82.6158 20.6107 68.2159C17.9356 61.422 13.0508 39.4162 26.2807 20.5164Z",
    fill: "#FFFAE6"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEasterChick);
export default __webpack_public_path__ + "static/media/easter-chick.294eb47ffb96b7081379660df107c2eb.svg";
export { ForwardRef as ReactComponent };